import { render, staticRenderFns } from "./serviceObjectFeedbackDetail.vue?vue&type=template&id=37340f9c&scoped=true&"
import script from "./serviceObjectFeedbackDetail.vue?vue&type=script&lang=ts&"
export * from "./serviceObjectFeedbackDetail.vue?vue&type=script&lang=ts&"
import style0 from "./serviceObjectFeedbackDetail.vue?vue&type=style&index=0&id=37340f9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37340f9c",
  null
  
)

export default component.exports